import manage from './manage'
import create from './create'
import sort from './sort'
import introduction from './introduction'
import buy from './buy'
import sell from './sell'
import { asyncLoad } from '@util'

export default {
  path: 'vr',
  component: asyncLoad(() => import('@components/LocalMerchant/VR')),
  indexRoute: {
    component: asyncLoad(() => import('@components/LocalMerchant/VR/List'))
  },
  stat: '全景管理/首页',
  childRoutes: [manage, create, sort, introduction, buy, sell]
}
